import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import {
  DsmContractDetails,
  DsmContractDocuments,
  DsmContractReviewedSteps,
  DsmContractStepReview,
  DsmContractStepReviewPayload
} from '../models/dsm-contract-details.models';

@Injectable({ providedIn: 'root' })
export class DsmContractDetailsService {
  readonly #api = inject(ApiCallingV2Service);
  readonly #baseUrl = `${inject(API_CONFIG).baseUrlV2}/dsm/contract-details`;

  readContractDetails(dealId: string): Observable<DsmContractDetails> {
    return this.#api.getData<DsmContractDetails>(`${this.#baseUrl}/${dealId}`, {
      showLoader: false,
      showMessage: false,
      showError: false
    });
  }

  readReviewedSteps(dealId: string): Observable<DsmContractReviewedSteps> {
    return this.#api.getData<DsmContractReviewedSteps>(`${this.#baseUrl}/${dealId}/reviewed`, {
      showLoader: false,
      showMessage: false
    });
  }

  updateStepReview(
    dealId: string,
    stepId: string,
    payload: DsmContractStepReviewPayload
  ): Observable<DsmContractStepReview> {
    return this.#api.putData<DsmContractStepReview>(`${this.#baseUrl}/${dealId}/steps/${stepId}/reviewed`, payload, {
      showLoader: false,
      showMessage: false
    });
  }

  readDocuments(dealId: string): Observable<DsmContractDocuments> {
    return this.#api.getData<DsmContractDocuments>(`${this.#baseUrl}/${dealId}/documents`, {
      showLoader: false,
      showMessage: false
    });
  }

  downloadSignedDocument(dealId: string, dealDocumentId: string, fileName: string): Observable<void> {
    return this.#api.downloadReportFile(
      `${this.#baseUrl}/${dealId}/documents/${dealDocumentId}/download-signed`,
      { showLoader: false, showMessage: false, showError: true },
      undefined,
      fileName
    );
  }
}
